import React from 'react'
import { useExportBatteryIncentivePoint, useGetBatteryIncentivePoints } from '../../api/point'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { BATTERY } from '../shared/companies'

export const BatteryIncentivePoints = () => {
  const columns = [
    { id: 'companyAccountId', label: 'Company Id' },
    { id: 'companyName', label: 'Company Name' },
    { id: 'priceGroup', label: 'Price Group' },
    { id: 'point', label: 'Total Points' },
    {
      id: 'categoryDetails',
      label: 'Point Details',
      view: ({ categoryDetails = {} }) => (
        <>
          {Object.entries(categoryDetails).map(([key, { quantity }]) => (
            <div key={key}>
              {key}: {quantity}
            </div>
          ))}
        </>
      ),
    },
    { id: 'salesId', label: 'Sales Id' },
  ]

  return (
    <PointPanelScreen
      title='Battery Incentive Point'
      htgCompany={BATTERY}
      useExportApi={useExportBatteryIncentivePoint}
      useGetPoints={useGetBatteryIncentivePoints}
      columns={columns}
      linkBase='battery-incentive-summary'
    />
  )
}
